import env from '@/config/env'
import request from '@/router/axios'

// 枚举查询接口
export const getCrmEnum = () => {
  return request({
    url: `${env.ferryUrl}/crm/enum`,
    method: 'GET'
  })
}

/**
 * 标签管理
 *
 */

// 查询标签列表
export const getMemberTagPage = (data) => {
  return request({
    url: `${env.ferryUrl}/member/tag/page`,
    method: 'POST',
    data
  })
}

// 新增标签
export const addMemberTag = (data) => {
  return request({
    url: `${env.ferryUrl}/member/tag/add`,
    method: 'POST',
    data
  })
}

// 编辑标签
export const editMemberTag = (data) => {
  return request({
    url: `${env.ferryUrl}/member/tag/edit`,
    method: 'POST',
    data
  })
}

// 改变标签状态
export const changeTagStatus = (params) => {
  return request({
    url: `${env.ferryUrl}/member/tag/changeStatus`,
    method: 'PUT',
    params
  })
}

// 查标签详情
export const getTagDetail = (data) => {
  return request({
    url: `${env.ferryUrl}/member/tag/detail?id=${data}`,
    method: 'GET'
  })
}

// 获取手动打标标签
export const getTagManual = () => {
  return request({
    url: `${env.ferryUrl}/member/tag/manual`,
    method: 'GET'
  })
}
